import { motion } from "motion/react";
import { useAnimatedCounter } from "~/hooks/animtations/useAnimatedCounter";

// Animated number component
export default function AnimatedNumber({
  value,
  delay,
  suffix = "",
  isDecimal = false,
  duration = 0,
  animationKey = 0,
}: {
  value: number;
  delay: number;
  suffix?: string;
  isDecimal?: boolean;
  duration?: number;
  animationKey?: number;
}) {
  const displayValue = useAnimatedCounter(
    value,
    delay,
    duration,
    animationKey,
    isDecimal,
  );
  return (
    <motion.span>
      {displayValue}
      {suffix}
    </motion.span>
  );
}
